import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  headerBadge: {
    background: "#38cfc4 !important",
    color: "#fff",
    borderRadius: 20,
    padding: "4px 8px",
    marginRight: 8,
  },
  headerVersion: {
    color: "#465869",
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: "normal",
  },
  gridWrapper: {
    padding: "15px 32px",
  },
  dateUpdated: {
    textAlign: "left",
  },
  readIcon: {
    fontSize: "18px",
    cursor: "pointer",
  },
  importantIcon: {
    fontSize: "15px",
    cursor: "pointer",
  },
  markAsUnreadButton: {
    whiteSpace: "nowrap",
  },
  loadingIcon: {
    color: "#475467",
  },
  button: {
    cursor: "pointer",
  },
}));

export default styles;
